import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Grid } from '@material-ui/core';
import Center from '../components/Layout/Center';
import Onboarding from './Onboarding';
import SetupVisualRecs from '../components/SetupVisualRecs/SetupVisualRecs';
import {
  onboardingRecsActivate,
  onboardingRecsCustomize,
  onboardingRecsPreview,
} from '../slices/OnboardingSlice';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function buildCards(history, shopId, t) {
  return [
    {
      id: 'step1',
      header: t('ui.onboardingVisualRecs.safelyPreviewRecommendations'),
      buttonColor: '#1E2248',
      buttonText: t('onboarding.action.preview'),
      buttonIcon: 'search',
      buttonOnClick: () => {
        const previewWin = window.open('about:blank', '_blank');
        return onboardingRecsPreview(previewWin);
      },
      meta: t('onboarding.recs.preview.description'),
    }, {
      id: 'step2',
      header: t('ui.onboardingVisualRecs.customizeRecommendationsAndStyle'),
      buttonColor: '#1E2248',
      buttonText: t('onboarding.action.customize'),
      buttonIcon: 'edit',
      buttonOnClick: () => {
        history.push(`/app/${shopId}/recs/settings`);
        return onboardingRecsCustomize();
      },
      meta: t('onboarding.recs.customize.description'),
    }, {
      id: 'step3',
      header: t('ui.onboardingVisualRecs.makeRecommendationsEnabledForYourCustomers'),
      buttonColor: 'var(--kea-color-primary)',
      buttonText: t('onboarding.action.activate'),
      buttonIcon: 'boat',
      buttonOnClick: () => {
        history.push(`/app/${shopId}/recs/dashboard`);
        return onboardingRecsActivate();
      },
      meta: t('onboarding.visualRecs.activate.description'),
    },
  ];
}

export default function OnboardingVisualRecs() {
  const { settings, onboarding } = useSelector((store) => store, undefined);
  const { shopId } = settings;
  const history = useHistory();
  const t = useLocalizedMessage();
  const cards = buildCards(history, shopId, t);
  // todo: use visualRecs object here
  if (!onboarding.recs.wizardCompleted) {
    return (
      <Grid container justifyContent="center" spacing={4}>
        <Center>
          <SetupVisualRecs />
        </Center>
      </Grid>
    );
  }

  if (!onboarding.recs.completed) {
    return (
      <Onboarding
        cards={cards}
        header={t('onboarding.visualRecs.title')}
        subheader1={t('onboarding.visualRecs.description')}
        subheader2={t('onboarding.visualRecs.stepsDescription')}
      />
    );
  }

  return <></>;
}
